export default __webpack_public_path__ + "static/media/hero.cf93b226.png";